module.exports = __webpack_public_path__ + "static/media/arrow_down.98454b54.svg";